<template>
    <Multiselect
        v-model="value"
        :mode="mode"
        :loading="loading"
        :placeholder="placeholder"
        :filter-results="false"
        :searchable="searchable"
        :min-chars="minChars"
        :resolve-on-load="resolveOnLoad == 1 ? true : false"
        :no-options-text="noOptionsText"
        :options="options"
        :clear-on-search="true"
        ref="multiselect"
        @keyup="getData"
    >

        <template v-slot:multiplelabel="{ values }">
            <div class="multiselect-multiple-label">
                {{ values.length }} vybrané
            </div>
        </template>

    </Multiselect>

    <input type="hidden" :name="name" :id="id" :value="value" required>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import axios from 'axios'
import Multiselect from '@vueform/multiselect'

export default {

    props: [
        'placeholder',
        'noOptionsText',
        'name',
        'id',
        'type',
        'label',
        'mode',
        'url',
        'resolveOnLoad'
    ],

    components: {
        Multiselect
    },

    setup(props) {

        const state = reactive({
            value: null,
            minChars: 2,
            multiselect: null,
            options: [],
            data: [],
            loading: false,
            searchable: false,
        })

        onMounted ( () => {
            if ( props.type === 'pharmacies' ) {
                getData()
            } else if (props.type === 'products') {
                state.searchable = true
            }
        })

        function getData() {
            state.loading = true
            state.options = []

            let inputs = document.querySelectorAll('.multiselect input'),
                search = ''

            if (props.type === 'products') {

                if (inputs.length > 0) {
                    search = inputs[0].getAttribute('modelvalue')
                }

                if (search.length < state.minChars) {
                    state.options = []
                    state.loading = false
                    return
                }
            }

            axios.post(props.url, {
                q: search,
            }).then(response => {
                if (response.status === 200) {
                    state.data = response.data.data;
                    //if (state.data != null) {
                    for (var i = 0; i < state.data.length; i++) {
                        let opt;
                        if (props.type === "pharmacies") {
                            opt = state.data[i].street + " " + state.data[i].street_number + ", " + state.data[i].city + " " + state.data[i].zip;
                        } else if (props.type === "products") {
                            opt = state.data[i].name;
                        }
                        let id = state.data[i].id;
                        let tmp = {label: opt, value: id}
                        state.options.push(tmp)
                    }
                    //}
                    state.loading = false
                } else
                    flash('Niečo sa pokazilo.', 'danger')
            }).catch(error => flash(error.message, 'danger'))
        }

        return {
            getData,
            ...toRefs(state),
        }
    }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
